module.exports = __webpack_public_path__ + "img/1164e40.jpg";